<template>
  <div>
    <q-banner class="bg-primary text-white">
      تنظیمات
    </q-banner>
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <q-expansion-item
            class="shadow-1 overflow-hidden q-ma-xs"
            style="border-radius: 10px"
            icon="vpn_key"
            label="تغییر کلمه عبور"
            header-class="bg-indigo-10 text-white"
            expand-icon-class="text-white"
            default-opened>
          <q-form autofocus greedy @submit="onSubmit" @reset="onReset">
            <q-card>
              <q-card-section>
                <q-banner inline-actions class="q-ma-xs bg-red-8 text-white rounded-borders">
                  <template v-slot:avatar>
                    <q-icon name="privacy_tip"/>
                  </template>
                  <p>
                    حساب کاربری و کلمه
                    عبور دریافتی از مجموعه نوران، جهت ورود به نرم افزارهای مجموعه، برای شما تعهد آور است، لذا در امن
                    نگداشتن
                    آن‌ها نهایت دقت را به عمل
                    آورید.
                  </p>
                  <ol>
                    <li>رمز عبور بایستی حداقل 8 حرف باشد.</li>
                    <li>رمز عبور بایستی متشکل از حروف، اعداد و کاراکترهای خاص باشد</li>
                  </ol>
                </q-banner>
                <q-input :dense="$q.screen.lt.md" v-model="passwordModel.currentPassword"
                         label="کلمه عبور فعلی"
                         :rules="[ val => val && val.length > 0 || 'کلمه عبور فعلی خود را وارد نمایید']"
                         :type="isOldPwd ? 'password' : 'text'" clearable filled dir="ltr"
                         autocomplete="current-password">
                  <template v-slot:append>
                    <q-icon
                        :name="isOldPwd ? 'visibility_off' : 'visibility'"
                        class="cursor-pointer"
                        @click="isOldPwd = !isOldPwd"
                    />
                  </template>
                </q-input>
                <q-input :dense="$q.screen.lt.md" v-model="passwordModel.newPassword"
                         label="کلمه عبور جدید"
                         :rules="[ val => val && val.length > 0 || 'کلمه عبور جدید خود را وارد نمایید']"
                         :type="isOldPwd ? 'password' : 'text'" clearable filled dir="ltr"
                         autocomplete="current-password">
                  <template v-slot:append>
                    <q-icon
                        :name="isOldPwd ? 'visibility_off' : 'visibility'"
                        class="cursor-pointer"
                        @click="isOldPwd = !isOldPwd"
                    />
                  </template>
                </q-input>
                <q-input :dense="$q.screen.lt.md" v-model="passwordModel.newPasswordRepeat"
                         label="تکرار کلمه عبور جدید"
                         :rules="[ val => val && val.length > 0 || 'کلمه عبور جدید خود را وارد نمایید' ,
                                val => val === passwordModel.newPassword  || 'کلمات عبور جدید و تکرار آن با هم تطابق ندارند']"
                         :type="isNewPwd ? 'password' : 'text'" clearable filled dir="ltr"
                         autocomplete="new-repeat-password">
                  <template v-slot:append>
                    <q-icon
                        :name="isNewPwd ? 'visibility_off' : 'visibility'"
                        class="cursor-pointer"
                        @click="isNewPwd = !isNewPwd"
                    />
                  </template>
                </q-input>
              </q-card-section>

              <q-separator/>

              <q-card-actions align="right">
                <q-btn color="primary" icon="check" type="submit">تایید</q-btn>
                <q-btn flat color="red" type="reset" icon="cancel">انصراف</q-btn>
              </q-card-actions>
            </q-card>
          </q-form>

        </q-expansion-item>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: "SettingsPanel",
  data() {
    return {
      isOldPwd: true,
      isNewPwd: true,
      passwordModel: {
        currentPassword: '',
        newPassword: '',
        newPasswordRepeat: ''
      }
    }
  },
  methods: {
    ...mapActions({
      ChangePassword: 'Authenticate/changePassword'
    }),
    onSubmit() {
      this.ChangePassword(this.passwordModel).then(() => {
        this.$q.notify({
          message: 'کلمه عبور تغییر داده شد',
          color: 'positive',
          position: 'top',
          type: 'positive'
        });
        this.onReset()
      }).catch(() => {
        this.$q.notify({
          message: 'امکان تغییر کلمه عبور وجود ندارد',
          color: 'red',
          position: 'top',
          type: 'negative'
        });
      });
    },
    onReset() {
      this.passwordModel.currentPassword = '';
      this.passwordModel.newPassword = '';
      this.passwordModel.newPasswordRepeat = '';
    }
  }
}
</script>

<style scoped>

</style>
